const sizes = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  _2xl: '1.5rem',
  _3xl: '1.875rem',
  _4xl: '2.25rem',
  _5xl: '3rem',
  _6xl: '3.75rem',
  _7xl: '4.5rem',
  _8xl: '6rem',
  _9xl: '8rem',
};

export default sizes;

export type SizesType = typeof sizes;
